import { forwardRef, MouseEvent, ReactNode, useContext } from 'react';
import { styled } from '@mui/material/styles';
import { shouldForwardProp as sysShouldForwardProp } from '@mui/system';
import IconButton, { IconButtonProps } from '../IconButton';
import AppBarInternalContext, { AppBarInternalContextShape } from './AppBarInternalContext';
import colors from '../theme/colors';

export interface AppBarInternalIconButtonProps {
  icon: ReactNode;
  color?: 'inherit' | 'primary' | 'default' | 'secondary';
  centerRipple?: boolean;
  onClick?: (e: MouseEvent) => void;
}

const AppBarInternalIconButtonRoot = styled(IconButton, {
  name: 'O2AppBar',
  slot: 'InternalIconButton',
  shouldForwardProp: (prop) => sysShouldForwardProp(prop) && prop !== 'isProd',
})<IconButtonProps & AppBarInternalContextShape>(({ theme, isProd }) => ({
  borderRadius: 0,
  alignSelf: 'stretch',
  padding: `0 ${theme.spacing(1)}`,
  backgroundColor: isProd ? colors.internal['500'] : colors.success['700'],
  '&:hover': {
    backgroundColor: isProd ? colors.internal['500'] : colors.success['700'],
  },
  margin: 0,
}));

/**
 * @deprecated Use AppBarInternal components from @o2/common-business
 */
const AppBarInternalIconButton = forwardRef<HTMLButtonElement, AppBarInternalIconButtonProps>((props, ref) => {
  const { icon, color = 'inherit', ...other } = props;
  const { isProd } = useContext(AppBarInternalContext);

  return (
    /* @ts-expect-error: "Color inherit not in list" */
    <AppBarInternalIconButtonRoot variant="circle" ref={ref} isProd={isProd} {...other} color={color}>
      {icon}
    </AppBarInternalIconButtonRoot>
  );
});

AppBarInternalIconButton.displayName = 'AppBarInternal.IconButton';

export default AppBarInternalIconButton;
